import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TABLE_SETTINGS, MESSAGES } from "../utills/constant";
import { useDispatch } from "react-redux";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { MdEdit } from "react-icons/md";
import { GoDatabase } from "react-icons/go";
import { LiaTrashRestoreAltSolid } from "react-icons/lia";
import { IoTrashBinOutline } from "react-icons/io5";
import {
  blockServer,
  updateService,
  getAllServer,
  saveNewServer,
  GetSingleServer,
} from "../store/actions/server";
const ServerTable = ({ userHeader, userProducts, loading }) => {
  const users = useSelector((state) => state.userManagement);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [Id, setId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = TABLE_SETTINGS.DEFAULT_PAGE_SIZE;
  const totalItems = userProducts.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const [formData, setFormData] = useState({
    name: "",
  });
  const toggleModal = () => {
    setEditModal(false);
  };

  useEffect(() => {
    if (Id) {
      dispatch(GetSingleServer(Id));
    }
  }, [dispatch, Id]);

  const allServer = useSelector((state) => state.server.servers);

  const singleServer = allServer.find((item) => item._id === Id);

  console.log("singleServer server ", singleServer);
  useEffect(() => {
    if (singleServer) {
      setFormData({
        name: singleServer.name || "",
      });
    }
  }, [singleServer]);

  // Call APIs on mount
  useEffect(() => {
    dispatch(getAllServer());
  }, [dispatch]);

  const fetchAllServer = () => {
    dispatch(getAllServer({}));
  };

  const handleSaveServer = (e) => {
    e.preventDefault();

    const updatedData = {
      ...formData,
      id: Id, // Add the id here
    };

    console.log("Form data being sent:", updatedData);

    dispatch(updateService({ id: Id, data: { name: formData.name } }));
    toast.success("server updated successfully!", {
      position: "top-right",
      autoClose: 600,
      onClose: () => {
        fetchAllServer(); // Refresh list
      },
    });

    setFormData({
      name: "",
      status: "1",
      id: -1,
    });
    setEditModal(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const currentItems = userProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    const halfWay = Math.floor(maxVisiblePages / 2);

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= halfWay + 1) {
      pages.push(
        ...Array.from({ length: maxVisiblePages - 1 }, (_, i) => i + 1),
        "..."
      );
    } else if (currentPage >= totalPages - halfWay) {
      pages.push(
        1,
        "...",
        ...Array.from(
          { length: maxVisiblePages - 1 },
          (_, i) => totalPages - (maxVisiblePages - 2) + i
        )
      );
    } else {
      pages.push(
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPages
      );
    }

    return pages;
  };

  const paginationNumbers = generatePageNumbers();

  const BlockServer = (id) => {
    const updatedData = {
      id: id,
    };

    console.log("Form data being sent:", id);

    dispatch(blockServer({ id: id })).then(() => {
      toast.success("server block successfully!", {
        position: "top-right",
        autoClose: 600,
        onClose: () => {
          fetchAllServer(); // Refresh list
        },
      });
    });
  };

  const handleUnblockServer = (id) => {
    dispatch(updateService({ id: id, data: { status: 1 } }));
    toast.success("Unblock server successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        fetchAllServer();
      },
    });
  };

  return (
    <div className="relative bg-card overflow-x-auto shadow-md sm:rounded-lg m-2">
      {loading ? (
        <div className="text-center text-gray-500">{MESSAGES.LOADING}</div>
      ) : totalItems === 0 ? (
        <div className="text-center text-gray-500">{MESSAGES.NO_DATA}</div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left bg-card text-gray-500">
              <thead className="text-xs text-white uppercase bg-[#02256d]">
                <tr>
                  <th scope="col" className="p-4">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        className="w-4 h-4 text-blue-800 border-gray-300 rounded focus:ring-[#02256d]"
                        aria-label="Select all"
                      />
                    </div>
                  </th>
                  {userHeader.map((header, index) => (
                    <th key={index} scope="col" className="px-6 py-3">
                      {header.label || header.key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((product) => (
                  <tr
                    key={product.id || product.email}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="w-4 p-4">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          className="w-4 h-4 text-[#02256d] border-gray-300 rounded focus:ring-[#02256d]"
                          aria-label={`Select ${product.name}`}
                        />
                      </div>
                    </td>
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium whitespace-nowrap"
                    >
                      {product.name}
                    </th>
                    <td className="px-6 py-4">{product.email}</td>
                    <td className="px-6 py-4">{product.phone}</td>
                    <td className="px-6 py-4">{product.roleId}</td>
                    <td className="px-6 py-4">{product.status}</td>
                    <td className="px-6 py-4 flex gap-5">
                      <button
                        className="px-2 py-1 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-600 hover:text-white"
                        title="Edit"
                        onClick={() => {
                          setEditModal(true);
                          setId(product._id);
                        }}
                      >
                        <MdEdit className="text-lg" />
                      </button>
                      <button title="Data" className="px-2 py-1 border border-green-600 text-green-600 rounded-lg hover:bg-green-600 hover:text-white">
                        <GoDatabase className="text-lg" />
                      </button>
                      {product?.status == "1" && (
                        <button
                          className="font-medium text-red-600  border  border-red-600  px-2 rounded-lg hover:text-white hover:bg-red-600"
                          title="Block"
                          onClick={() => BlockServer(product._id)}
                        >
                          <IoTrashBinOutline className="text-lg" />
                        </button>
                      )}
                      {product?.status == "0" && (
                        <button
                          onClick={() => handleUnblockServer(product?._id)}
                          title="Unblock"
                          className="font-medium text-green-600  border  border-green-600  px-2 rounded-lg hover:text-white hover:bg-green-600"
                        >
                          <LiaTrashRestoreAltSolid className="text-lg" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {editModal && (
              <div className="fixed inset-0 mt-4 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
                <div className="relative p-4 w-full max-w-md h-auto overflow-hidden">
                  <div className="relative bg-card rounded-lg shadow max-h-[90vh] overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                      <h3 className="text-lg font-semibold text-text">
                        Add New Data Location
                      </h3>
                      <button
                        type="button"
                        className="text-text bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600"
                        onClick={toggleModal}
                      >
                        <IoClose className="w-5 h-5" />
                      </button>
                    </div>

                    {/* Modal Body */}
                    <form className="p-4 md:p-5" onSubmit={handleSaveServer}>
                      <div className="grid gap-4 mb-4 grid-cols-1">
                        <div>
                          <label
                            htmlFor="name"
                            className="block mb-2 text-sm font-medium text-text"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            placeholder="Enter location"
                            required
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="w-full justify-center text-white inline-flex items-center bg-[#02256d] hover:bg-blue-950 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            )}

            {/* Pagination */}
            <nav className="flex items-center justify-between p-4">
              <span className="text-sm text-black">
                Showing{" "}
                <span className="font-semibold">
                  {(currentPage - 1) * itemsPerPage + 1}
                </span>{" "}
                -{" "}
                <span className="font-semibold">
                  {Math.min(currentPage * itemsPerPage, totalItems)}
                </span>{" "}
                of <span className="font-semibold">{totalItems}</span>
              </span>
              <ul className="flex gap-1">
                {/* Previous Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 disabled:opacity-50"
                    aria-label="Previous Page"
                  >
                    Previous
                  </button>
                </li>

                {/* Page Numbers */}
                {paginationNumbers.map((page, index) => (
                  <li key={index}>
                    {page === "..." ? (
                      <span className="px-3 py-1 text-gray-500 bg-white border border-gray-300">
                        ...
                      </span>
                    ) : (
                      <button
                        onClick={() => handlePageChange(page)}
                        className={`px-3 py-1 border border-gray-300 ${
                          currentPage === page
                            ? "bg-[#02256d] text-white"
                            : "bg-white text-gray-500 hover:bg-[#02256d] hover:text-white"
                        }`}
                        aria-label={`Page ${page}`}
                      >
                        {page}
                      </button>
                    )}
                  </li>
                ))}

                {/* Next Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 disabled:opacity-50"
                    aria-label="Next Page"
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}
    </div>
  );
};

export default ServerTable;
